// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/location_list.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";

/**
 * @generated from message knop.ui.v1.api.LocationListResponse
 */
export class LocationListResponse extends Message<LocationListResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.api.LocationMetadata locations = 1;
   */
  locations: LocationMetadata[] = [];

  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 2;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<LocationListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.LocationListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locations", kind: "message", T: LocationMetadata, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LocationListResponse {
    return new LocationListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LocationListResponse {
    return new LocationListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LocationListResponse {
    return new LocationListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LocationListResponse | PlainMessage<LocationListResponse> | undefined, b: LocationListResponse | PlainMessage<LocationListResponse> | undefined): boolean {
    return proto3.util.equals(LocationListResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.LocationMetadata
 */
export class LocationMetadata extends Message<LocationMetadata> {
  /**
   * @generated from field: string code = 1;
   */
  code = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  constructor(data?: PartialMessage<LocationMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.LocationMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LocationMetadata {
    return new LocationMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LocationMetadata {
    return new LocationMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LocationMetadata {
    return new LocationMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: LocationMetadata | PlainMessage<LocationMetadata> | undefined, b: LocationMetadata | PlainMessage<LocationMetadata> | undefined): boolean {
    return proto3.util.equals(LocationMetadata, a, b);
  }
}

